// extracted by mini-css-extract-plugin
export default {"ddl-btn":"ViewEmailTemplate_ddl-btn__s9fGO"};